let env = "prd";
let envkey = "key";

const ANTHENTICATION = {
  qas: {
    apiUrl: "http://qas-ssonapi.homepro.local/api",
    apiPermGroupCode: "OTHER",
  },
  prd: {
    apiUrl: "http://ssonapi.homepro.local/api",
    apiPermGroupCode: "OTHER",
  },
};
const CORRECTIVE_API = {
  qas: {
    apiUrl: "http://qas-correctiveapi.homepro.local/api",
    apiPermGroupCode: "OTHER",
  },
  prd: {
    apiUrl: "http://correctiveapi.homepro.local/api",
    apiPermGroupCode: "OTHER",
  },
};
const CONTRACTORBILLING_API = {
  qas: {
    apiUrl: "https://qas-billsvcwebapi.homepro.co.th/api",
    apiPermGroupCode: "DS",
  },
  prd: {
    apiUrl: "https://billsvcwebapi.homepro.co.th/api",
    apiPermGroupCode: "DS",
  },
};
const LOGIN = {
  qas: {
    webUrl: "http://qsson.homepro.local/WebForm/LoginForm.aspx",
    apiPermGroupCode: "OTHER",
  },
  prd: {
    webUrl: "http://sson.homepro.local/WebForm/LoginForm.aspx",
    apiPermGroupCode: "OTHER",
  },
};
const GOOGLEMAPSAPIKEY = {
  key: {
    apiKey: "AIzaSyA4d8vNo37p1_MFiozWEQBwGh0SqKsRCzs",
  },
};
const MD5KEY = {
  key: {
    secretKey: "HomePro@2023",
  },
};
const APPLICATION = {
  qas: {
    system: "CMEx",
    appNo: "A288"
  },
  prd: {
    system: "CMEx",
    appNo: "A290"
  }
};
const TOKEN = {
  qas: {
    apiUrl: "https://qas-apigwin.homepro.co.th/hpg/qas",
  },
  prd: {
    apiUrl: "https://apigwin.homepro.co.th/hpg/prd",
  },
};
const HEADER = {
  qas: {
    scope: "Worker",
    client_id: "58e367891a773b051a5a3abba3230469",
    client_secret: "26b23cbfc80a4bdef35392a8edde0ed3",
    grant_type: "client_credentials",
    secretKey: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJTaW5nbGVTaWduT25XZWJBUEkiLCJleHAiOjE3MDUwNTUyMTMuMH0.xMQMs8niZVmP8dEcVr_ymYUC7B4qMhZeCkhY8eUZJ3E"

  },
  prd: {
    scope: "Worker",
    client_id: "9eab0ec3a23f0f15de155e3a6da842af",
    client_secret: "8e5b9db42cd7c1a85a8a0f56fbe073ba",
    grant_type: "client_credentials",
  },
};
const CMGATEWAY = {
  qas: {
    apiUrl: "https://qas-apigwin.homepro.co.th/hpg/qas/worker",
  },
  prd: {
    apiUrl: "https://apigwin.homepro.co.th/hpg/prd/worker",
  },
};

const appSettings = {
  services: {
    Authentication: {
      apiUrl: ANTHENTICATION[env].apiUrl,
      apiPermGroupCode: ANTHENTICATION[env].apiPermGroupCode,
    },
    CorrectiveApi: {
      apiUrl: CORRECTIVE_API[env].apiUrl,
      apiPermGroupCode: CORRECTIVE_API[env].apiPermGroupCode,
    },
    ContractorBillingApi: {
      apiUrl: CONTRACTORBILLING_API[env].apiUrl,
      apiPermGroupCode: CONTRACTORBILLING_API[env].apiPermGroupCode,
    },
    Login: {
      webUrl: LOGIN[env].webUrl,
    },
    googleKey: {
      GoogleMapsAPIKey: {
        key: GOOGLEMAPSAPIKEY[envkey].apiKey,
      },
    },
    Token:{
      secretKey: HEADER[env].client_secret,
    },
    TOKEN: {
      apiUrl: TOKEN[env].apiUrl,
    },
    Header: {
      scope: HEADER[env].scope,
      client_id: HEADER[env].client_id,
      client_secret: HEADER[env].client_secret,
      grant_type: HEADER[env].grant_type,
    },
    application: {
      system: APPLICATION[env].system,
      appNo: APPLICATION[env].appNo,
    },
    CMGateWay: {
      apiUrl: CMGATEWAY[env].apiUrl,
    },
  },
  auth: {
    Encrypt: {
      secretKey: MD5KEY[envkey].secretKey,
    },
  },
  configKey: {
    jobStatus: "WORK_JOBSTATUS",
    discountDate: "TRADE_DISCOUNT_DATE",
    discountPercent: "TRADE_DISCOUNT_PERCENT",
    SpecialBillType: "SPECIAL_BILL_TYPE"
  }
};

export default appSettings;
